// Persisted playback prefs for <AudioPlayer>. Global localStorage so a
// listener configures speed/gain once and they apply to every recording
// in Call History and admin Recordings.

import { safeRead, safeWrite } from './safeStorage'

export const SPEED_KEY = 'pixellab.audio.speed'
export const GAIN_KEY = 'pixellab.audio.gain'

export const SPEED_VALUES = [1, 1.25, 1.5, 2] as const
export type SpeedValue = (typeof SPEED_VALUES)[number]

export const GAIN_MIN = 0
export const GAIN_MAX = 3
export const GAIN_DEFAULT = 1
export const SPEED_DEFAULT: SpeedValue = 1

export function getSpeed(): SpeedValue {
  const raw = safeRead(SPEED_KEY)
  if (!raw) return SPEED_DEFAULT
  const n = Number(raw)
  return SPEED_VALUES.includes(n as SpeedValue) ? (n as SpeedValue) : SPEED_DEFAULT
}

export function setSpeed(v: SpeedValue): void {
  safeWrite(SPEED_KEY, String(v))
}

export function getGain(): number {
  const raw = safeRead(GAIN_KEY)
  if (!raw) return GAIN_DEFAULT
  const n = Number(raw)
  if (!isFinite(n)) return GAIN_DEFAULT
  if (n < GAIN_MIN) return GAIN_MIN
  if (n > GAIN_MAX) return GAIN_MAX
  return n
}

export function setGain(v: number): void {
  if (!isFinite(v)) return
  const clamped = Math.max(GAIN_MIN, Math.min(GAIN_MAX, v))
  safeWrite(GAIN_KEY, String(clamped))
}

export function nextSpeed(current: SpeedValue): SpeedValue {
  const idx = SPEED_VALUES.indexOf(current)
  const next = idx === -1 ? 0 : (idx + 1) % SPEED_VALUES.length
  return SPEED_VALUES[next]
}
